@if (loading) {
    <div class="fx-r fx-f-1-1 fx-pc-c-c">
        @if (!cameraError) {
            <mat-spinner></mat-spinner>
        }
        @if (cameraError) {
            <p>Nepodařilo se načíst kameru.</p>
        }
    </div>
}
<div class="fx-c" [hidden]="loading || cameraError">
    <video #cameraPreview [hidden]="!showCameraPreview" autoplay="autoplay"></video>
    <canvas #cameraCanvas [hidden]="showCameraPreview"></canvas>
    <div class="action-buttons fx-r fx-pc-c-sa">
        @if (showCameraPreview) {
            <button
                class="btn btn-regular orange"
                type="button"
                mat-button="mat-button"
                (click)="takeSnapshotFromCamera()">
                <div class="fx-r fx-pc-c-c">
                    <mat-icon>photo_camera</mat-icon>
                    <span>&nbsp;Vyfotit</span>
                </div>
            </button>
        }
        @if (!showCameraPreview) {
            <button class="btn btn-regular" type="button" mat-button="mat-button" (click)="showCameraPreview = true">
                <div class="fx-r fx-pc-c-c">
                    <mat-icon>refresh</mat-icon>
                    <span>&nbsp;Vyfotit znovu</span>
                </div>
            </button>
        }
        @if (!showCameraPreview) {
            <button class="btn btn-regular orange" type="button" mat-button="mat-button" (click)="confirm()">
                <div class="fx-r fx-pc-c-c">
                    <mat-icon>upload</mat-icon>
                    <span>&nbsp;Nahrát</span>
                </div>
            </button>
        }
    </div>
</div>
